import * as React from 'react';
import { styled } from './druid/./druid/Utilities';
import { ICalloutProps, ICalloutContentStyles, ICalloutContentStyleProps } from '/druid/Callout.types';
import { CalloutContentBase } from '/druid/CalloutContent.base';
import { getStyles } from '/druid/CalloutContent.styles';

export const CalloutContent: React.FunctionComponent<ICalloutProps> = styled<
  ICalloutProps,
  ICalloutContentStyleProps,
  ICalloutContentStyles
>(CalloutContentBase, getStyles, undefined, { scope: 'CalloutContent' });
